import { WebsiteContentMessage } from '../../../../../../types';
import { DomainRule } from '../../types';
import moment from 'moment-timezone';

export const SegmentTimesInvalid = 'segmentTimesInvalid';

/**
 * Validates that segment times are valid (no end time before start time)
 * This is done on campaign save because the modals don't support long validation messages for times
 * @param onsiteMessages
 * @returns boolean
 */
export const SegmentTimesAreValid = (onsiteMessages: Array<WebsiteContentMessage>): DomainRule => {
  const results = onsiteMessages.map(message => {
    const scheduling = message?.scheduling;
    if (!scheduling) {
      return true;
    }

    if (!scheduling.startDate || !scheduling.endDate) {
      return true;
    }

    if (!scheduling.startTime || !scheduling.endTime) {
      return true;
    }

    if (scheduling.startTime && scheduling.endTime) {
      const [startHours, startMinutes] = scheduling.startTime.split(':').map(Number);
      const [endHours, endMinutes] = scheduling.endTime.split(':').map(Number);

      const startDate = moment(scheduling.startDate);
      const endDate = moment(scheduling.endDate);
      startDate.set({ hours: startHours, minutes: startMinutes });
      endDate.set({ hours: endHours, minutes: endMinutes });

      if (endDate.isBefore(startDate)) {
        return false;
      }
    }

    return true;
  });

  if (results.flat().some(c => c === false)) {
    return {
      result: 'fail',
      ruleKey: SegmentTimesInvalid,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
